module.exports = __webpack_public_path__ + "media/stylesheets/opensans300-bf89c60125f0f0df34b8cbaa96ef052f.woff2";